import AddVacancyQuestionVideo from './AddVacancyQuestionVideo.page';

export default AddVacancyQuestionVideo;